import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Grid,
  Paper,
  Typography
} from '@mui/material';
import { Fingerprint as FingerprintIcon } from '@mui/icons-material';
import GirviPageShell from './GirviPageShell';
import BlackDaybookView from './BlackDaybookView';
import baseURL from '../../baseURL';
import { receiptService } from '../../services/receiptService';

const BlackUserDashboard = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fingerprintScanning, setFingerprintScanning] = useState(false);
  const [fingerprintMessage, setFingerprintMessage] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const profileResponse = await fetch(`${baseURL}/auth/profile`, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` }
        });
        const profileData = await profileResponse.json();

        if (!profileResponse.ok) {
          throw new Error(profileData.message || 'Failed to fetch profile');
        }

        setUserData(profileData.data.user);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleFingerprintScan = async () => {
    try {
      setFingerprintScanning(true);
      setFingerprintMessage('Scanning fingerprint...');
      const result = await receiptService.searchPledgeByFingerprint(60);
      if (result.matches?.length) {
        setFingerprintMessage(`Found ${result.matches.length} matching pledge(s).`);
      } else {
        setFingerprintMessage('No matching pledges found.');
      }
    } catch (err) {
      setFingerprintMessage(err.message || 'Failed to scan fingerprint');
    } finally {
      setFingerprintScanning(false);
    }
  };

  if (error) {
    return (
      <GirviPageShell title="Dashboard" subtitle="VPS B" compact>
        <Alert severity="error">{error}</Alert>
      </GirviPageShell>
    );
  }

  return (
    <GirviPageShell
      title="Black Dashboard"
      subtitle="Black book"
      chipLabel="BLACK"
      loading={loading}
      compact
      actions={
        <Button
          variant="contained"
          size="small"
          startIcon={<FingerprintIcon />}
          onClick={handleFingerprintScan}
          disabled={fingerprintScanning}
          sx={{ bgcolor: '#c9a24d', color: '#0b1220', fontWeight: 700, '&:hover': { bgcolor: '#e0c49a' } }}
        >
          {fingerprintScanning ? 'Scanning...' : 'Scan Fingerprint'}
        </Button>
      }
    >

        {fingerprintMessage && (
          <Alert severity="info" sx={{ mb: 3 }}>
            {fingerprintMessage}
          </Alert>
        )}

        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Profile Overview
              </Typography>
              {userData && (
                <>
                  <Typography>Name: {userData.name}</Typography>
                  <Typography>Company: {userData.companyName}</Typography>
                  <Typography>Address: {userData.address || '—'}</Typography>
                  <Typography>Mobile: {userData.mobileNumber || '—'}</Typography>
                  <Typography>License Number: {userData.licenseNumber || '—'}</Typography>
                </>
              )}
            </Paper>
          </Grid>
        </Grid>

        <BlackDaybookView title="Black Daybook (Illegal Transactions)" />
    </GirviPageShell>
  );
};

export default BlackUserDashboard;
